"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/index.tsx
var src_exports = {};
__export(src_exports, {
  AuthProvider: () => AuthProvider,
  AxiosError: () => import_axios.AxiosError,
  authSetup: () => authSetup,
  httpClient: () => httpClient,
  s3HttpClient: () => s3HttpClient
});
module.exports = __toCommonJS(src_exports);

// src/hooks/auth/AuthProvider.tsx
var import_react = require("react");
var import_auth = require("aws-amplify/auth");
var import_react_hooks = require("@bcba/react-hooks");
var import_jsx_runtime = require("react/jsx-runtime");
var AuthContext = (0, import_react.createContext)(null);
var AuthProvider = ({ children }) => {
  const [authTokens, setAuthTokens] = (0, import_react.useState)(null);
  const [lastAccessedAt, setLastAccessedAt] = (0, import_react.useState)();
  const debouncedAccessedAt = (0, import_react_hooks.useDebounce)(lastAccessedAt, 2e3);
  const getCurrentSession = () => __async(void 0, null, function* () {
    var _a;
    try {
      const tokens = yield (0, import_auth.fetchAuthSession)({ forceRefresh: true });
      setAuthTokens((_a = tokens.tokens) != null ? _a : null);
    } catch (error) {
      console.error("Failed to fetch auth tokens:", error);
    }
  });
  const cleanUpSession = (0, import_react.useCallback)(
    (shouldSignOut = true) => {
      setAuthTokens(null);
      if (shouldSignOut) {
        (0, import_auth.signOut)();
      }
    },
    [setAuthTokens, import_auth.signOut]
  );
  (0, import_react.useEffect)(() => {
    getCurrentSession();
  }, [debouncedAccessedAt]);
  const onResponseErrorCallback = (0, import_react.useCallback)(
    (error) => {
      var _a, _b, _c, _d;
      const alreadyExpired = ((_b = (_a = authTokens == null ? void 0 : authTokens.accessToken) == null ? void 0 : _a.payload) == null ? void 0 : _b.exp) ? ((_d = (_c = authTokens == null ? void 0 : authTokens.accessToken) == null ? void 0 : _c.payload) == null ? void 0 : _d.exp) < (/* @__PURE__ */ new Date()).getTime() / 1e3 : false;
      if (alreadyExpired) {
        cleanUpSession(true);
      }
      throw error;
    },
    [cleanUpSession, authTokens]
  );
  (0, import_react.useEffect)(() => {
    const interceptorId = httpClient.interceptors.request.use(
      (config) => __async(void 0, null, function* () {
        var _a, _b;
        const tokens = yield (0, import_auth.fetchAuthSession)();
        if ((_a = tokens == null ? void 0 : tokens.tokens) == null ? void 0 : _a.accessToken) {
          config.headers = __spreadProps(__spreadValues({}, config.headers), {
            Authorization: `Bearer ${(_b = tokens == null ? void 0 : tokens.tokens) == null ? void 0 : _b.accessToken.toString()}`
          });
          setLastAccessedAt(tokens.tokens.accessToken.payload.exp);
        }
        return config;
      }),
      (error) => Promise.reject(error)
    );
    return () => {
      httpClient.interceptors.request.eject(interceptorId);
    };
  }, []);
  (0, import_react.useEffect)(() => {
    const interceptorId = httpClient.interceptors.response.use((config) => {
      return config;
    }, onResponseErrorCallback);
    return () => {
      httpClient.interceptors.response.eject(interceptorId);
    };
  }, [onResponseErrorCallback]);
  const value = { authTokens, cleanUpSession };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AuthContext.Provider, { value, children });
};

// src/index.tsx
var import_axios = __toESM(require("axios"));

// src/components/Authenticator.tsx
var import_styles = require("@aws-amplify/ui-react/styles.css");
var import_ui_react3 = require("@aws-amplify/ui-react");
var import_aws_amplify = require("aws-amplify");

// src/components/Amplify/SignIn/Header.tsx
var import_ui = require("@agrotoken-tech/ui");
var import_react_hooks2 = require("@bcba/react-hooks");
var import_jsx_runtime2 = require("react/jsx-runtime");
var AmplifySignInHeader = ({
  defaultLogo
}) => {
  const { t } = (0, import_react_hooks2.useTranslation)();
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)(import_ui.Flex, { pt: 8, px: 8, flexDirection: "column", gap: 6, children: [
    defaultLogo,
    /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)(import_ui.Flex, { flexDirection: "column", children: [
      /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(import_ui.Heading, { size: "sm", children: t("amplify.signIn.title") }),
      /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(import_ui.Text, { children: t("amplify.signIn.subtitle") })
    ] })
  ] });
};

// src/components/Amplify/SignIn/Footer.tsx
var import_ui2 = require("@agrotoken-tech/ui");
var import_ui_react = require("@aws-amplify/ui-react");
var import_react_hooks3 = require("@bcba/react-hooks");
var import_jsx_runtime3 = require("react/jsx-runtime");
var AmplifySignInFooter = (props) => {
  const { t } = (0, import_react_hooks3.useTranslation)();
  const { toForgotPassword } = (0, import_ui_react.useAuthenticator)();
  const { onClickSignUp } = props;
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_ui2.Center, { pb: 8, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)(import_ui_react.Flex, { direction: "column", children: [
    /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_ui2.Button, { onClick: toForgotPassword, size: "small", variant: "linkPrimary", children: t("amplify.forgotYourPassword") }),
    onClickSignUp ? /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)(import_ui_react.Flex, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_ui2.Text, { children: t("amplify.doNotHaveAnAccount") }),
      /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_ui2.Button, { size: "small", variant: "linkPrimary", onClick: onClickSignUp, children: t("amplify.signup") })
    ] }) : null
  ] }) });
};

// src/components/Authenticator.tsx
var import_utils2 = require("aws-amplify/utils");
var import_ui_react4 = require("@aws-amplify/ui-react");
var import_react_hooks4 = require("@bcba/react-hooks");
var import_cognito = require("aws-amplify/auth/cognito");

// src/hooks/hub/HubProvider.tsx
var import_react2 = require("react");
var import_utils = require("aws-amplify/utils");
var import_jsx_runtime4 = require("react/jsx-runtime");
var HubContext = (0, import_react2.createContext)(null);
var HubProvider = ({ children }) => {
  const [justSignedIn, setJustSignedIn] = (0, import_react2.useState)(false);
  (0, import_react2.useEffect)(() => {
    const authListener = ({ channel, payload: { event } }) => {
      if (channel === "auth") {
        switch (event) {
          case "signedIn":
            setJustSignedIn(true);
            break;
          default:
            break;
        }
      }
    };
    const hubListenerCancel = import_utils.Hub.listen("auth", authListener);
    return hubListenerCancel;
  }, []);
  const value = { justSignedIn, setJustSignedIn };
  return /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(HubContext.Provider, { value, children });
};

// src/components/Amplify/ForceNewPassword/FormFields.tsx
var import_ui_react2 = require("@aws-amplify/ui-react");
var import_ui3 = require("@agrotoken-tech/ui");
var import_react_i18next = require("react-i18next");
var import_jsx_runtime5 = require("react/jsx-runtime");
var AmplifyForceNewPassword = () => {
  const { t } = (0, import_react_i18next.useTranslation)();
  return /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)(import_jsx_runtime5.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(import_ui_react2.Authenticator.ForceNewPassword.FormFields, {}),
    /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)(import_ui_react2.Flex, { gap: "4px", children: [
      /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(import_ui3.Box, { height: "16px", width: "16px", marginTop: "4px", children: /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(import_ui3.FiAlertCircle, {}) }),
      /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(import_ui3.Text, { children: t("amplify.passwordTooltip") })
    ] })
  ] });
};

// src/components/Authenticator.tsx
var import_jsx_runtime6 = require("react/jsx-runtime");
import_utils2.I18n.putVocabularies(import_ui_react4.translations);
import_utils2.I18n.setLanguage("es");
var getAuthenticator = (aws_project_region, aws_cognito_region, aws_user_pools_id, aws_user_pools_web_client_id) => {
  import_aws_amplify.Amplify.configure({
    aws_project_region,
    aws_cognito_region,
    aws_user_pools_id,
    aws_user_pools_web_client_id
  });
  import_cognito.cognitoUserPoolsTokenProvider.setKeyValueStorage(import_utils2.sessionStorage);
  return function Authenticator2(_a) {
    var _b = _a, {
      children,
      translations: translations2 = {},
      defaultLogo,
      components,
      formFields,
      onClickSignUp
    } = _b, rest = __objRest(_b, [
      "children",
      "translations",
      "defaultLogo",
      "components",
      "formFields",
      "onClickSignUp"
    ]);
    const { t } = (0, import_react_hooks4.useTranslation)();
    const defaultTranslations = {
      "Reset Password": t("amplify.resetPassword.title"),
      "Incorrect username or password.": t(
        "amplify.incorrectUsernameOrPassword"
      ),
      "username is required to signIn": t("amplify.emailRequiredToSignIn"),
      "password is required to signIn": t("amplify.passwordRequiredToSignIn"),
      "username is required to resetPassword": t(
        "amplify.emailRequiredToResetPassword"
      ),
      "newPassword is required to confirmResetPassword": t(
        "amplify.newPasswordIsRequiredToConfirmResetPassword"
      ),
      "confirmationCode is required to confirmResetPassword": t(
        "amplify.confirmationCodeIsRequiredToConfirmResetPassword"
      ),
      "Invalid verification code provided, please try again.": t(
        "amplify.invalidVerificationCodeProvided"
      ),
      "Password must have at least 8 characters": t(
        "amplify.passwordAtLeast8Characters"
      ),
      "Please confirm your Password": t("amplify.confirmPassword.placeholder"),
      "Password does not conform to policy: Password must have symbol characters": t("amplify.passwordMustHaveSpecialCharacters"),
      "Password does not conform to policy: Password must have lowercase characters": t("amplify.passwordMustHaveLowercaseCharacters"),
      "Password does not conform to policy: Password must have uppercase characters": t("amplify.passwordMustHaveUppercaseCharacters"),
      "Password does not conform to policy: Password must have numeric characters": t("amplify.passwordMustHasNumber")
    };
    import_utils2.I18n.putVocabularies({
      en: __spreadValues(__spreadValues({}, defaultTranslations), translations2),
      es: __spreadValues(__spreadValues({}, defaultTranslations), translations2)
    });
    const defaultComponents = {
      ForceNewPassword: {
        FormFields: () => /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(AmplifyForceNewPassword, {})
      },
      SignIn: {
        Header: () => /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(AmplifySignInHeader, { defaultLogo }),
        Footer: () => /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(AmplifySignInFooter, { onClickSignUp })
      }
    };
    const defaultFormFields = {
      signIn: {
        username: {
          label: t("common.email"),
          placeholder: t("amplify.email.placeholder")
        },
        password: {
          label: t("common.password"),
          placeholder: t("amplify.password.placeholder")
        }
      },
      forceNewPassword: {
        password: {
          label: t("common.password"),
          placeholder: t("amplify.password.placeholder")
        }
      },
      forgotPassword: {
        username: {
          label: t("common.email"),
          placeholder: t("amplify.email.placeholder")
        }
      },
      confirmResetPassword: {
        confirmation_code: {
          label: t("common.confirmationCode"),
          placeholder: t("amplify.confirmationCode.placeholder")
        },
        password: {
          label: t("amplify.newPassword.label"),
          placeholder: t("amplify.newPassword.placeholder")
        },
        confirm_password: {
          label: t("amplify.confirmPassword.label"),
          placeholder: t("amplify.confirmPassword.placeholder")
        }
      }
    };
    return /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(HubProvider, { children: /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
      import_ui_react3.Authenticator,
      __spreadProps(__spreadValues({
        components: __spreadValues(__spreadValues({}, defaultComponents), components),
        formFields: __spreadValues(__spreadValues({}, defaultFormFields), formFields)
      }, rest), {
        children: /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(AuthProvider, { children })
      })
    ) });
  };
};

// src/index.tsx
var import_ui_react5 = require("@aws-amplify/ui-react");

// src/hooks/auth/useAuth.ts
var import_react3 = require("react");
function useAuth() {
  return (0, import_react3.useContext)(AuthContext);
}

// src/hooks/hub/useHub.ts
var import_react4 = require("react");
function useHub() {
  return (0, import_react4.useContext)(HubContext);
}

// src/index.tsx
var httpClient = import_axios.default.create({
  headers: {
    "Content-type": "application/json"
  }
});
var s3HttpClient = import_axios.default.create({});
httpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    var _a, _b;
    if ((_b = (_a = error == null ? void 0 : error.response) == null ? void 0 : _a.data) == null ? void 0 : _b.code) {
      error.code = error.response.data.code;
    }
    return Promise.reject(error);
  }
);
var authSetup = ({
  baseApiUrl,
  aws_project_region,
  aws_cognito_region,
  aws_user_pools_id,
  aws_user_pools_web_client_id
}) => {
  httpClient.defaults.baseURL = baseApiUrl || "";
  return {
    Authenticator: getAuthenticator(
      aws_project_region,
      aws_cognito_region,
      aws_user_pools_id,
      aws_user_pools_web_client_id
    ),
    useAuthenticator: import_ui_react5.useAuthenticator,
    useAuth,
    useHub
  };
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  AuthProvider,
  AxiosError,
  authSetup,
  httpClient,
  s3HttpClient
});
